module.exports = __webpack_public_path__ + "static/media/gatorBackup.12140031.svg";